import { DataroomAccessType } from '@dataroom/entity/DataroomAccessType';
import spacesStyles from '@dealroadshow/uikit-styles/helpers/spaces.module.scss';

export const documentationStateOptions = {
  preliminary: {
    value: 1,
    label: 'Preliminary',
    wrapperClassName: spacesStyles.mbm,
    dataTest: 'preliminaryRadioButton',
  },
  final: {
    value: 2,
    label: 'Final',
    dataTest: 'finalOnlyRadioButton',
  },
};

export const radioOptions: any = [
  documentationStateOptions.preliminary,
  documentationStateOptions.final,
];

export const formRadioGroupName = 'docState';
export const requestPhysicalCopyName = 'requestPhysicalCopy';

export const documentationToPublicityMapping = {
  [documentationStateOptions.preliminary.value]: DataroomAccessType.Restricted,
  [documentationStateOptions.final.value]: DataroomAccessType.InviteOnly,
};
